import * as React from 'react';
const IconCross = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    {...props}
  >
    <path
      stroke="#396DFF"
      strokeLinecap="round"
      d="M1 16 15.85 1.15M1 1l14.85 14.85"
    />
  </svg>
);
export default IconCross;
